import React from "react";
import styled from '@emotion/styled';
import ImgInstructors from "../assets/images/CNC-Instructors.jpg";
import Button from '@mui/material/Button';
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const HomeInstructors = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/Sedes");
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const ImgDiv = styled.div`
    background-image: url(${ImgInstructors});
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    min-height: 30em;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 2em;

    @media (max-width: 768px) {
      padding: 2em 1em;
    }
  `;

  const BlackDiv = styled.div`
    background: linear-gradient(0.25turn, transparent, black, transparent);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1em;
    margin-top: 2em;
    text-align: center;

    @media (max-width: 768px) {
      flex-direction: column;
      margin-top: 1em;
    }
  `;

  const Title = styled.p`
    font-family: "League Gothic", serif;
    font-size: clamp(32px, 5vw, 80px);
    color: white;
    margin: 0;
    line-height: 1.1;
  `;

  const SubTitle = styled.span`
    font-family: "League Gothic", serif;
    font-size: inherit;
    color: #12b854;
  `;

  const ButtonText = styled.p`
    font-family: "DM Sans", serif;
    color: white;
    font-size: 18px;
    font-weight: 700;
    margin: 0;

    @media (max-width: 480px) {
      font-size: 16px;
    }
  `;

  const DivButtonText = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    @media (max-width: 480px) {
      flex-direction: column;
      gap: 5px;
    }
  `;

  return (
    <>
      <ImgDiv>
        <BlackDiv>
          <Title>
            ¿QUIERES FORMAR PARTE DEL EQUIPO VOLUNTARIO DE&nbsp;
            <SubTitle>INSTRUCTORES</SubTitle>?
          </Title>
        </BlackDiv>

        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            backgroundColor: "#12b854",
            color: "white",
            borderRadius: "30px",
            "&:hover": {
              backgroundColor: "#0d6834"
            },
            padding: "12px 24px",
            marginTop: "30px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            fontSize: "16px"
          }}
        >
          <DivButtonText>
            <ButtonText>BUSCA EN TU ESTADO</ButtonText>
            <FaArrowRight color="white" size={20} />
          </DivButtonText>
        </Button>
      </ImgDiv>
    </>
  );
};

export default HomeInstructors;
